module.exports = __webpack_public_path__ + "media/images/googlemap-276ae61cbbd9a3d6021880cfd42ab4d7.gif";